import type ISpacerTab from "../../../constructionCalculationsNew/components/tabs/types/ISpacerTab";
import type CalculationMastTabsNewProps from "./CalculationMastTabsNewProps";
import type IBeamTab from "./types/IBeamTab";
import type IMastTab from "./types/IMastTab";
import useCalculationMastTabsNew from "./useCalculationMastTabsNew";
import MastTab from "./components/MastTab";
import BeamTab from "./components/BeamTab";
import SpacerTab from "./components/SpacerTab";

const CalculationMastTabsNew: React.FunctionComponent<CalculationMastTabsNewProps> = ({
    selectedMastNo,
    construction,
    calculationResults
}) => {
    const tabs = useCalculationMastTabsNew(construction, calculationResults);

     return (
        <>
          {tabs.map((tab, index) => {
            const isMastTab = (candidate: IMastTab | IBeamTab | ISpacerTab): candidate is IMastTab =>
              (candidate as IMastTab).number !== undefined;

            if (isMastTab(tab)) {
              return (
                <MastTab key={index} tab={tab} selectedMastNo={selectedMastNo} />
              );
            }

            const isBeamTab = (candidate: IBeamTab | ISpacerTab): candidate is IBeamTab =>
              (candidate as IBeamTab).type !== undefined;
            if (isBeamTab(tab)) {
              return <BeamTab key={index} tab={tab} />;
            }

            return <SpacerTab key={index} />;
          })}
        </>
  );
};

export default CalculationMastTabsNew;